/**
 * Toast Container Component
 * Displays toast notifications in the top-right corner
 */
export function ToastContainer({ toasts, onDismiss }) {
  if (!toasts || toasts.length === 0) {
    return null;
  }

  return (
    <div className="t24-toast-container">
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          id={toast.id}
          message={toast.message}
          type={toast.type}
          onDismiss={onDismiss}
        />
      ))}
    </div>
  );
}

/**
 * Individual Toast Component with dismiss button
 */
function Toast({ id, message, type = 'info', onDismiss }) {
  const getIcon = () => {
    switch (type) {
      case 'success':
        return '✓';
      case 'error':
        return '✕';
      case 'info':
      default:
        return 'ℹ';
    }
  };

  return (
    <div className={`t24-toast ${type}`}>
      <span className="t24-toast-icon">{getIcon()}</span>
      <span className="t24-toast-message">{message}</span>
      {onDismiss && (
        <button
          className="t24-toast-dismiss"
          onClick={(e) => {
            e.stopPropagation();
            onDismiss(id);
          }}
          aria-label="Dismiss"
        >
          ×
        </button>
      )}
    </div>
  );
}
